import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const ListTable = ({ rows }) => {
  let key = 0;
  return (
    <div style={{display:'block', overflowX: 'scroll'}}>
    <Table size="small">
      <TableBody>
        {rows.map(row => (
          <TableRow key={key++}>
            <TableCell key={key++}>
              <b>{row[0]}</b>
            </TableCell>
            <TableCell key={key++}>{row[1]}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </div>
  );
};

export default ListTable;
